import * as React from "react";
import { ColorType } from "@hubper/theme";

import SelectMenu from "../../elements/SelectMenu";
import SelectMenuItem from "../../elements/SelectMenuItem";

import Button from "./Button";
import { IconName } from "../../elements/Icon";
import MenuLayer from "../MenuLayer";
import { PoseGroup } from "react-pose";
import composeRefs from "../../util/composeRefs";
import { useOutsideClick } from "../../hooks";

type Props = {
  style?: React.CSSProperties;
  className?: string;
  options: Array<{ value: string | number; display: string }>;
  onOptionClick: (value: string | number) => void;
  stretch?: boolean;
  disabled?: boolean;
  text?: string;
  iconBefore?: IconName;
  iconAfter?: IconName;
  icon?: IconName;
  c: string | ColorType;
};

function DropdownButton(
  {
    style,
    className,
    options,
    onOptionClick,
    stretch,
    disabled,
    text,
    iconBefore,
    iconAfter,
    icon,
    c
  }: Props,
  ref: any
) {
  const [isOpen, setOpen] = React.useState(false);
  const buttonRef = React.useRef<HTMLDivElement>(null);
  const menuRef = React.useRef<HTMLDivElement>(null);
  useOutsideClick([buttonRef, menuRef], () => {
    if (isOpen) {
      setOpen(false);
    }
  });

  return (
    <>
      <Button
        ref={composeRefs(ref, buttonRef)}
        stretch={stretch}
        disabled={disabled}
        style={style}
        className={className}
        c={c}
        text={text}
        icon={icon}
        iconBefore={iconBefore}
        iconAfter={iconAfter}
        isOpen={isOpen}
        onClick={() => setOpen(!isOpen)}
      />
      <MenuLayer element={buttonRef.current}>
        {style => (
          <PoseGroup flipMove={false}>
            {isOpen && (
              <SelectMenu ref={menuRef} key="menu" style={style}>
                {options.map(option => {
                  return (
                    <SelectMenuItem
                      onClick={() => {
                        setOpen(false);
                        onOptionClick(option.value);
                      }}
                      key={option.value}
                    >
                      {option.display}
                    </SelectMenuItem>
                  );
                })}
              </SelectMenu>
            )}
          </PoseGroup>
        )}
      </MenuLayer>
    </>
  );
}

export default React.forwardRef(DropdownButton);
